import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';

import styles from './PriceField.css';

import { format, getAmount } from '../../shared/emoluments';
import TextField from '../form/TextField';

function PriceField(props) {
  const { value, ...otherProps } = props;

  return (
    <div>
      <TextField
        inputProps={{ type: 'number' }}
        {...otherProps}
      />

      {value != null && value !== '' &&
        <div>
          <div className={styles.priceTitle}>
            Prix T.T.C.
          </div>

          <div className={styles.price}>
            {format(getAmount(value))}
          </div>
        </div>
      }
    </div>
  );
}

export default connect((state, props) => ({
  value: get(state, props.model),
}))(PriceField);



/** WEBPACK FOOTER **
 ** ./client/act/PriceField.js
 **/